import { faBriefcaseMedical, faHardDrive, faHelmetSafety } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Card, CardBody, Col, Container, Row, Button, ButtonGroup, FormGroup, Label, Input } from "reactstrap";
import instance from "../../axiosInstance";
import { useProfileContext } from "../../context/profile";
import useError from "../../hooks/useError";
import Header from "../UI/Header";
import HeaderSubtitle from "../UI/HeaderSubtitle";
import HeaderTitle from "../UI/HeaderTitle";
import CustomDate, { months, years } from "../UI/forms/CustomDate";
import Chart from 'react-apexcharts';
import moment from "moment";


export const selectHideArrowStyle = {
    dropdownIndicator: (base) => ({
        ...base,
        display: "none",
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: "none",
    }),
};

const styles = `
  .switch {
    position: relative;
    display: inline-block;
    width: 106px;
    height: 28px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 4px;
  }

  .slider::before {
    position: absolute;
    content: "";
    height: 23px !important;
    width: 23px !important;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: .4s;
    z-index: 2;
    box-shadow: 0 0 2px rgba(0,0,0,0.2);
  }

  .slider-text {
    font-size: 10px;
    font-weight: 500;
    color: white;
    position: absolute;
    transition: .4s;
    user-select: none;
    width: 85px;
    text-align: center;
  }

  .slider-text.left {
    right: 1px;
  }

  .slider-text.right {
    left: 1px;
  }

  input:not(:checked) + .slider .slider-text.left {
    opacity: 1;
  }

  input:checked + .slider .slider-text.right {
    opacity: 1;
  }

  input:not(:checked) + .slider .slider-text.right {
    opacity: 0;
  }

  input:checked + .slider .slider-text.left {
    opacity: 0;
  }

  input:checked + .slider {
    background-color: #2196F3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  input:checked + .slider:before {
    transform: translateX(78px);
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .status-label {
    font-size: 13px;
    font-weight: 500;
    color: #6c757d;
    margin-left: 8px;
    user-select: none;
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

const IBDashboard = ({ theme }) => {
    const { handleError } = useError();
    const { profile } = useProfileContext();
    const [dashboardInfo, setDashboardInfo] = useState(null);
    const [chartOptions, setChartOptions] = useState({});
    const [chartSeries, setChartSeries] = useState([]);

    const [categories, setCategories] = useState([]);
    const [values, setValues] = useState([]);
    const [categoriesPersonal, setCategoriesPersonal] = useState([]);
    const [valuesPersonal, setValuesPersonal] = useState([]);
    const [chartOptionsPersonal, setChartOptionsPersonal] = useState({});
    const [chartSeriesPersonal, setChartSeriesPersonal] = useState([]);
    const [categoryHire, setCategoryHire] = useState([]);
    const [valuesHire, setValuesHire] = useState([]);
    const [chartOptionsHire, setChartOptionsHire] = useState({});
    const [chartSeriesHire, setChartSeriesHire] = useState([]);
    const [categoryRepair, setCategoryRepair] = useState([]);
    const [valuesRepair, setValuesRepair] = useState([]);
    const [chartOptionsRepair, setChartOptionsRepair] = useState({});
    const [chartSeriesRepair, setChartSeriesRepair] = useState([]);
    const date = new Date();
    const selectedYear = sessionStorage.getItem("admin-selectedYear") || date.getFullYear();
    const selectedMonth = sessionStorage.getItem("admin-selectedMonth") || date.getMonth() + 1;
    const selectedFileHandler = sessionStorage.getItem("admin-selectedFileHandler");
    const [month, setMonth] = useState({ value: date.getMonth() + 1, label: months[date.getMonth()] });
    const [year, setYear] = useState(selectedYear ? { value: selectedYear, label: selectedYear } : { value: date.getFullYear(), label: date.getFullYear() });
    const [fileHandler, setFileHandler] = useState(selectedFileHandler ? JSON.parse(selectedFileHandler) : null);

    // New state for date range toggle and from/to dates - using Date objects
    const [useMonthYear, setUseMonthYear] = useState(true);
    const [fromDate, setFromDate] = useState(new Date(moment().startOf('month')));
    const [toDate, setToDate] = useState(new Date());
    const [dashboardLoading, setDashboardLoading] = useState(false);

    const data = {
        labels: dashboardInfo?.data_current?.map((d) => d.label) || ["Generates", "Rejected", "Transfers", "Pack", "Bikes"],
        datasets: [
            {
                data: dashboardInfo?.data_current?.map((d) => d.total) || [],
                backgroundColor: ["#153d77", theme.primary, theme.warning, theme.danger, "#E8EAED"],
                borderColor: "transparent",
            },
        ],
    };

    useEffect(() => {
        (async function () {
            try {
                setDashboardLoading(true);
                const { data } = await instance.get("/dashboard/ib", {
                    params: useMonthYear ? {
                        current_year: year?.value || null,
                        current_month: month?.value || null,
                        month_year: true
                    } : {
                        from_date: moment(fromDate).format('YYYY-MM-DD'),
                        to_date: moment(toDate).format('YYYY-MM-DD'),
                        month_year: false
                    },
                });
                setDashboardInfo(data.data);
                setDashboardLoading(false);
            } catch (error) {
                handleError(error);
                setDashboardLoading(false);
            }
        })();
    }, [fileHandler?.value, month?.value, year?.value, fromDate, toDate]);


    useEffect(() => {
        if (dashboardInfo) {
            // Insurance Broker Claims
            const categories = Object.keys(dashboardInfo.ibClaimCases);
            const values = Object.values(dashboardInfo.ibClaimCases);
            setCategories(categories);
            setValues(values);

            // Personal Injury Claims
            const categoriesPersonal = Object.keys(dashboardInfo.piClaimCases);
            const valuesPersonal = Object.values(dashboardInfo.piClaimCases);
            setCategoriesPersonal(categoriesPersonal);
            setValuesPersonal(valuesPersonal);

            // Hire Claims
            const categoriesHire = Object.keys(dashboardInfo.hireClaimCases);
            const valuesHire = Object.values(dashboardInfo.hireClaimCases);
            setCategoryHire(categoriesHire);
            setValuesHire(valuesHire);

            const chartOptions = {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 4,
                        columnWidth: '60%',
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                        colors: ['#ffffff'],
                        fontWeight: 600
                    }
                },
                xaxis: {
                    categories: categories
                },
                colors: ['#4e73df']
            };

            const chartSeries = [
                {
                    name: 'Claims',
                    data: values
                }
            ];
            setChartOptions(chartOptions);
            setChartSeries(chartSeries);

            const chartOptionsPersonal = {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 4,
                        columnWidth: '60%',
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                        colors: ['#ffffff'],
                        fontWeight: 600
                    }
                },
                xaxis: {
                    categories: categoriesPersonal
                },
                colors: ['#1cc88a']
            };

            const chartSeriesPersonal = [
                {
                    name: 'Claims',
                    data: valuesPersonal
                }
            ];
            setChartOptionsPersonal(chartOptionsPersonal);
            setChartSeriesPersonal(chartSeriesPersonal);

            const chartOptionsHire = {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 4,
                        columnWidth: '60%',
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                        colors: ['#ffffff'],
                        fontWeight: 600
                    }
                },
                xaxis: {
                    categories: categoriesHire
                },
                colors: ['#36b9cc']
            };

            const chartSeriesHire = [
                {
                    name: 'Claims',
                    data: valuesHire
                }
            ];
            setChartOptionsHire(chartOptionsHire);
            setChartSeriesHire(chartSeriesHire);



            // Repair Claims
            const categoriesRepair = Object.keys(dashboardInfo.repairClaimCases);
            const valuesRepair = Object.values(dashboardInfo.repairClaimCases);
            setCategoryRepair(categoriesRepair);
            setValuesRepair(valuesRepair);

            const chartOptionsRepair = {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 4,
                        columnWidth: '60%',
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                        colors: ['#ffffff'],
                        fontWeight: 600
                    }
                },
                xaxis: {
                    categories: categoriesRepair
                },
                colors: ['#4e73df']
            };

            const chartSeriesRepair = [
                {
                    name: 'Claims',
                    data: valuesRepair
                }
            ];
            setChartOptionsRepair(chartOptionsRepair);
            setChartSeriesRepair(chartSeriesRepair);
        }
    }, [dashboardInfo]);

    return (
        <>
            <style>
                {`
                .w-160 {
                    width: 160px;
                }
            `}
            </style>
            <Container fluid>
                <Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <HeaderTitle>Welcome, {profile?.full_name}</HeaderTitle>
                            <HeaderSubtitle>
                                <div className="fs-18 my-3"><br /></div>
                            </HeaderSubtitle>
                        </div>
                        <div className="position-absolute top-0 right-0" style={{ right: '10px' }}>
                            <div className="d-flex align-items-center mb-3">
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={!useMonthYear}
                                        onChange={(e) => setUseMonthYear(!useMonthYear)}
                                    />
                                    <span className="slider round">
                                        <span className="slider-text left">Month/Year</span>
                                        <span className="slider-text right">Date Range</span>
                                    </span>
                                </label>
                            </div>

                            <div className="d-flex" style={{ minHeight: '38px', width: '340px' }}>
                                <div style={{ width: '160px', marginRight: '12px' }}>
                                    {useMonthYear ? (
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            placeholder="Month"
                                            isClearable
                                            styles={selectHideArrowStyle}
                                            value={month}
                                            onChange={(selectedOption) => {
                                                setMonth(selectedOption);
                                                selectedOption ? sessionStorage.setItem("admin-selectedMonth", selectedOption.value) : sessionStorage.removeItem("admin-selectedMonth");
                                            }}
                                            options={months.map((month, index) => ({ value: index + 1, label: month }))}
                                        />
                                    ) : (
                                        <FormGroup className="mb-0">
                                            <CustomDate
                                                startDate={fromDate}
                                                setStartDate={setFromDate}
                                                id="fromDate"
                                                placeholder="From Date"
                                            />
                                        </FormGroup>
                                    )}
                                </div>
                                <div style={{ width: '160px' }}>
                                    {useMonthYear ? (
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            placeholder="Year"
                                            styles={selectHideArrowStyle}
                                            value={year}
                                            onChange={(selectedOption) => {
                                                setYear(selectedOption);
                                                selectedOption ? sessionStorage.setItem("admin-selectedYear", selectedOption.value) : sessionStorage.removeItem("admin-selectedYear");
                                            }}
                                            options={years.map((year) => ({ value: year, label: year }))}
                                        />
                                    ) : (
                                        <FormGroup className="mb-0">
                                            <CustomDate
                                                startDate={toDate}
                                                setStartDate={setToDate}
                                                id="toDate"
                                                placeholder="To Date"
                                            />
                                        </FormGroup>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Header>
                {dashboardLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <Row className="g-4">
                        <Col lg={6} md={12} className="mb-4">
                            <Card className="border-0 shadow-sm h-100">
                                <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="flex-shrink-0 me-3 mr-3">
                                            <div className="bg-primary bg-opacity-10 p-3 rounded-circle">
                                                <FontAwesomeIcon icon={faHelmetSafety} className="text-white fa-lg" />
                                            </div>
                                        </div>
                                        <div>
                                            <h4 className="mb-0 fw-bold">Claims Overview</h4>
                                        </div>
                                    </div>
                                    <div className="chart-container position-relative mb-4">
                                        <Chart
                                            options={{
                                                ...chartOptions,
                                                chart: {
                                                    ...chartOptions.chart,
                                                    background: 'transparent',
                                                    fontFamily: 'inherit',
                                                    toolbar: { show: false },
                                                    animations: {
                                                        enabled: true,
                                                        easing: 'easeinout',
                                                        speed: 800
                                                    }
                                                },
                                                colors: ['#4e73df'],
                                                grid: {
                                                    borderColor: '#f1f1f1',
                                                    strokeDashArray: 4,
                                                    padding: { top: 0, right: 0, bottom: 0, left: 0 }
                                                },
                                                dataLabels: {
                                                    enabled: true,
                                                    style: {
                                                        fontSize: '12px',
                                                        colors: ['#ffffff'],
                                                        fontWeight: 600
                                                    }
                                                },
                                                plotOptions: {
                                                    bar: {
                                                        borderRadius: 4,
                                                        columnWidth: '60%',
                                                    }
                                                }
                                            }}
                                            series={chartSeries}
                                            type="bar"
                                            height={280}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-sm align-middle mb-0">                                            
                                            <tbody>
                                                {categories.map((cat, index) => (
                                                    <tr key={index}>
                                                        <td className="fw-medium">{cat}</td>
                                                        <td className="text-right fw-bold text-primary">{values[index]}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className="fw-medium">Total</td>
                                                    <td className="text-right fw-bold text-primary">{values.reduce((acc, curr) => acc + curr, 0)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col lg={6} md={12} className="mb-4">
                            <Card className="border-0 shadow-sm h-100">
                                <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="flex-shrink-0 me-3 mr-3">
                                            <div className="bg-success bg-opacity-10 p-3 rounded-circle">
                                                <FontAwesomeIcon icon={faBriefcaseMedical} className="text-white fa-lg" />
                                            </div>
                                        </div>
                                        <div>
                                            <h4 className="mb-0 fw-bold">Personal Injury</h4>
                                        </div>
                                    </div>
                                    <div className="chart-container position-relative mb-4">
                                        <Chart
                                            options={{
                                                ...chartOptionsPersonal,
                                                chart: {
                                                    ...chartOptionsPersonal.chart,
                                                    background: 'transparent',
                                                    fontFamily: 'inherit',
                                                    toolbar: { show: false },
                                                    animations: {
                                                        enabled: true,
                                                        easing: 'easeinout',
                                                        speed: 800
                                                    }
                                                },
                                                colors: ['#1cc88a'],
                                                grid: {
                                                    borderColor: '#f1f1f1',
                                                    strokeDashArray: 4,
                                                    padding: { top: 0, right: 0, bottom: 0, left: 0 }
                                                },
                                                dataLabels: {
                                                    enabled: true,
                                                    style: {
                                                        fontSize: '12px',
                                                        colors: ['#ffffff'],
                                                        fontWeight: 600
                                                    }
                                                },
                                                plotOptions: {
                                                    bar: {
                                                        borderRadius: 4,
                                                        columnWidth: '60%',
                                                    }
                                                }
                                            }}
                                            series={chartSeriesPersonal}
                                            type="bar"
                                            height={280}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-sm align-middle mb-0">                                            
                                            <tbody>
                                                {categoriesPersonal.map((cat, index) => (
                                                    <tr key={index}>
                                                        <td className="fw-medium">{cat}</td>
                                                        <td className="text-right fw-bold text-success">{valuesPersonal[index]}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className="fw-medium">Total</td>
                                                    <td className="text-right fw-bold text-primary">{valuesPersonal.reduce((acc, curr) => acc + curr, 0)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col lg={6} md={12} className="mb-4">
                            <Card className="border-0 shadow-sm h-100">
                                <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="flex-shrink-0 me-3 mr-3">
                                            <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                                                <FontAwesomeIcon icon={faHardDrive} className="text-light fa-lg" />
                                            </div>
                                        </div>
                                        <div>
                                            <h4 className="mb-0 fw-bold">Hire Claims</h4>
                                        </div>
                                    </div>
                                    <div className="chart-container position-relative mb-4">
                                        <Chart
                                            options={{
                                                ...chartOptionsHire,
                                                chart: {
                                                    ...chartOptionsHire.chart,
                                                    background: 'transparent',
                                                    fontFamily: 'inherit',
                                                    toolbar: { show: false },
                                                    animations: {
                                                        enabled: true,
                                                        easing: 'easeinout',
                                                        speed: 800
                                                    }
                                                },
                                                colors: ['#36b9cc'],
                                                grid: {
                                                    borderColor: '#f1f1f1',
                                                    strokeDashArray: 4,
                                                    padding: { top: 0, right: 0, bottom: 0, left: 0 }
                                                },
                                                dataLabels: {
                                                    enabled: true,
                                                    style: {
                                                        fontSize: '12px',
                                                        colors: ['#ffffff'],
                                                        fontWeight: 600
                                                    }
                                                },
                                                plotOptions: {
                                                    bar: {
                                                        borderRadius: 4,
                                                        columnWidth: '60%',
                                                    }
                                                }
                                            }}
                                            series={chartSeriesHire}
                                            type="bar"
                                            height={280}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-sm align-middle mb-0">                                            
                                            <tbody>
                                                {categoryHire.map((cat, index) => (
                                                    <tr key={index}>
                                                        <td className="fw-medium">{cat}</td>
                                                        <td className="text-right fw-bold text-info">{valuesHire[index]}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className="fw-medium">Total</td>
                                                    <td className="text-right fw-bold text-primary">
                                                        {valuesHire.reduce((acc, curr, index) =>
                                                            ['Other', 'On-Hire', 'Pending', 'Reject'].includes(categoryHire[index]) ? acc + curr : acc
                                                            , 0)}
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col lg={6} md={12} className="mb-4">
                            <Card className="border-0 shadow-sm h-100">
                                <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="flex-shrink-0 me-3 mr-3">
                                            <div className="bg-warning bg-opacity-10 p-3 rounded-circle">
                                                <FontAwesomeIcon icon={faHardDrive} className="text-light fa-lg" />
                                            </div>
                                        </div>
                                        <div>
                                            <h4 className="mb-0 fw-bold">Repair Claims</h4>
                                        </div>
                                    </div>
                                    <div className="chart-container position-relative mb-4">
                                        <Chart
                                            options={{
                                                ...chartOptionsRepair,
                                                chart: {
                                                    ...chartOptionsRepair.chart,
                                                    background: 'transparent',
                                                    fontFamily: 'inherit',
                                                    toolbar: { show: false },
                                                    animations: {
                                                        enabled: true,
                                                        easing: 'easeinout',
                                                        speed: 800
                                                    }
                                                },
                                                colors: ['#36b9cc'],
                                                grid: {
                                                    borderColor: '#f1f1f1',
                                                    strokeDashArray: 4,
                                                    padding: { top: 0, right: 0, bottom: 0, left: 0 }
                                                },
                                                dataLabels: {
                                                    enabled: true,
                                                    style: {
                                                        fontSize: '12px',
                                                        colors: ['#ffffff'],
                                                        fontWeight: 600
                                                    }
                                                },
                                                plotOptions: {
                                                    bar: {
                                                        borderRadius: 4,
                                                        columnWidth: '60%',
                                                    }
                                                }
                                            }}
                                            series={chartSeriesRepair}
                                            type="bar"
                                            height={280}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-sm align-middle mb-0">                                            
                                            <tbody>
                                                {categoryRepair.map((cat, index) => (
                                                    <tr key={index}>
                                                        <td className="fw-medium">{cat}</td>
                                                        <td className="text-right fw-bold text-info">{valuesRepair[index]}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className="fw-medium">Total</td>
                                                    <td className="text-right fw-bold text-primary">{valuesRepair.reduce((acc, curr) => acc + curr, 0)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}

            </Container>

        </>
    );
};
export default connect((store) => ({
    theme: store.theme.currentTheme,
}))(IBDashboard);
